/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/building_construction_medium'
export default icon
